export const DEFAULT_CHAT_MODEL_ID = 'gemini-3.8-flash';

export interface ChatModelOption {
  id: string;
  label: string;
  hint: string;
}

/** Espelha `CHAT_MODEL_CATALOG` da API — só admin vê o picker. */
export const CHAT_MODEL_OPTIONS: ChatModelOption[] = [
  {
    id: DEFAULT_CHAT_MODEL_ID,
    label: '3.8 Flash',
    hint: 'Padrão',
  },
  {
    id: 'gemini-3.1-pro-preview',
    label: '3.1 Pro',
    hint: 'Avançado',
  },
  {
    id: 'gemini-2.5-flash',
    label: '2.5 Flash',
    hint: 'Leve',
  },
];

const CHAT_MODEL_IDS = new Set(CHAT_MODEL_OPTIONS.map((item) => item.id));
const FLASH_MODEL_ALIASES = new Set(['gemini-3.7-flash']);

export function normalizeChatModelId(value: unknown): string {
  const id = typeof value === 'string' ? value.trim() : '';
  if (FLASH_MODEL_ALIASES.has(id)) return DEFAULT_CHAT_MODEL_ID;
  return CHAT_MODEL_IDS.has(id) ? id : DEFAULT_CHAT_MODEL_ID;
}

export function resolveChatModelOption(id: string | null | undefined): ChatModelOption {
  const normalized = normalizeChatModelId(id);
  return (
    CHAT_MODEL_OPTIONS.find((item) => item.id === normalized) ??
    CHAT_MODEL_OPTIONS[0]
  );
}
